/** @file This file contains the component for the assignment item to be shown in the sidebar. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import AssignmentDate from '@/components/AssignmentDate';
import AssignmentName from '@/components/AssignmentName';
import { AssignmentStateViewer } from '@/components/AssignmentState';
import CourseName from '@/components/CourseName';
import { Icon } from '@/components/Icon';
import * as models from '@/models';
import { UIPrefsStore } from '@/store';
import './style.less';
import { Settings } from '@codegrade/icons';
export default tsx.component({
    name: 'assignment-list-item',
    functional: true,
    props: {
        assignment: p(models.Assignment).required,
        small: p(Boolean).default(false),
        currentId: p(Number).optional,
        showCourseName: p(Boolean).default(true),
        sbloc: p(String).optional,
        noPopover: p(Boolean).default(false),
    },
    /**
     * Renders the list item for an assignment to be shown in the sidebar.
     *
     * @param _ Vue's hyperscript function.
     * @param ctx The render context.
     * @returns The rendered component.
     */
    render(_, ctx) {
        const { assignment, small, currentId, showCourseName, noPopover, sbloc } = ctx.props;
        const course = assignment.maybeCourse;
        const selected = assignment.id === currentId;
        const examBadgeVariant = UIPrefsStore.darkMode() !== selected ? 'light' : 'primary';
        const routeName = ctx.parent.$route.name;
        let linkBody;
        if (small) {
            linkBody = (<div class="d-flex flex-row align-items-center">
                    <AssignmentName assignment={assignment} badgeVariant={examBadgeVariant}/>
                    <AssignmentDate assignment={assignment} tenantId={assignment.tenantId} relative withoutLockDate/>
                </div>);
        }
        else {
            linkBody = [
                <div class="d-flex flex-row">
                    <AssignmentName assignment={assignment} badgeVariant={examBadgeVariant}/>
                    <AssignmentStateViewer assignment={assignment}/>
                </div>,
            ];
            if (showCourseName && course.isJust()) {
                linkBody.push(<small class="course text-truncate">
                        <CourseName course={course.value}/>
                    </small>);
            }
            linkBody.push(<AssignmentDate assignment={assignment} tenantId={assignment.tenantId} relative/>);
        }
        let manageLink;
        if (!small && assignment.canManage && course.isJust()) {
            manageLink = (<router-link v-b-popover_topleft_hover_focus_window={noPopover ? '' : 'Manage assignment'} class={{
                    'sidebar-item manage-link align-text-bottom': true,
                    selected: selected && routeName === 'manage_assignment',
                }} aria-label={`Manage assignment '${assignment.name}'`} to={{
                    name: 'manage_assignment',
                    params: {
                        courseId: course.value.id.toString(10),
                        assignmentId: assignment.id.toString(10),
                    },
                    query: { sbloc },
                }}>
                    <Icon class="align-baseline" icon={Settings}/>
                </router-link>);
        }
        return (<li class={[
                ctx.data.staticStyle,
                ctx.data.class,
                'sidebar-list-item assignment-list-item',
                { 'light-selected': selected, 'small-item': small },
            ]} style={[ctx.data.staticStyle, ctx.data.style]}>
                <router-link class={{
                'sidebar-item overflow-hidden flex-grow-1': true,
                selected: selected && (small || routeName === 'assignment_submissions'),
            }} aria-label={`Submissions for assignment '${assignment.name}'`} to={{
                name: 'assignment_submissions',
                params: {
                    courseId: course.mapOrDefault(c => c.id.toString(10), '-1'),
                    assignmentId: assignment.id.toString(10),
                },
                query: { sbloc },
            }}>
                    {linkBody}
                </router-link>

                {manageLink}
            </li>);
    },
});
